import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/customer-member-cards', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/customer-member-cards/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/customer-member-cards/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/customer-member-cards', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formModel = (options = {}) => {
  return httpClient
    .get('/api/v1/customer-member-cards/form-view-models', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}


export const checkExist = data => {
  return httpClient
    .post('/api/v1/customer-member-cards/check-exists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}


export const destroy = id => {
  return httpClient
    .delete(`/api/v1/customer-member-cards/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}


export const assignCustomer = (id, data) => {
  return httpClient
    .post(`/api/v1/customer-member-cards/${id}/assign-customer`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}


export const previewInvoice = id => {
  return httpClient
    .get(`/api/v1/customer-member-cards/${id}/invoice-preview`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}


export const generateInvoice = (id, data) => {
  return httpClient
    .post(`/api/v1/customer-member-cards/${id}/generate-invoice`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}


export default { get, store, formModel, checkExist, find, update, destroy, assignCustomer, previewInvoice, generateInvoice }